// Test data pentru demonstrarea tuturor scenariilor NIS 2

export interface TestEntityData {
  cui: string;
  denumire: string;
  adresaSediu: string;
  codPostal: string;
  email: string;
  siteWeb: string;
  telefonFix: string;
  telefonMobil: string;
  puncteLucru: string[];
  caenPrincipal: { cod: string; denumire: string };
  caenSecundar: { cod: string; denumire: string }[];
  nrSalariati: number;
  cifraAfaceri: number;
  active: number;
  persoanaContact: {
    nume: string;
    email: string;
    telefon: string;
  };
  // Flags pentru scenarii specifice
  isAdminPublic?: boolean;
  isEntitateaCritica?: boolean;
  isFurnizorDNS?: boolean;
  isPrestatorQTSP?: boolean;
  isRegistruTLD?: boolean;
  needsImpactAnalysis?: boolean;
  scenario: string;
  description: string;
}

export const TEST_ENTITIES: TestEntityData[] = [
  {
    cui: "12345678",
    denumire: "SC ENERGIE ELECTRIC SRL",
    adresaSediu: "Calea Victoriei nr. 125, București, Sector 1",
    codPostal: "010073",
    email: "contact@energie-electric.ro",
    siteWeb: "www.energie-electric.ro",
    telefonFix: "021.456.7890",
    telefonMobil: "0722.345.678",
    puncteLucru: [
      "București - Sediu Central",
      "Ploiești - Centrul de Distribuție",
      "Constanța - Unitatea Regională",
    ],
    caenPrincipal: {
      cod: "3511",
      denumire: "Producerea energiei electrice",
    },
    caenSecundar: [
      { cod: "3512", denumire: "Transportul energiei electrice" },
      { cod: "3513", denumire: "Distribuirea energiei electrice" },
    ],
    nrSalariati: 850,
    cifraAfaceri: 125000000,
    active: 78000000,
    persoanaContact: {
      nume: "Elena Ionescu",
      email: "elena.ionescu@energie-electric.ro",
      telefon: "0722.345.678",
    },
    scenario: "ENTITATE MARE ANEXA 1 → ESENȚIALĂ AUTOMAT",
    description:
      "Entitate de dimensiune MARE cu servicii din Anexa 1 (energie). Se încadrează automat ca ESENȚIALĂ fără alte verificări.",
    needsImpactAnalysis: false,
  },

  {
    cui: "23456789",
    denumire: "SC TELECOM CONNECT SRL",
    adresaSediu: "Bdul Libertății nr. 45, Cluj-Napoca, Cluj",
    codPostal: "400123",
    email: "info@telecom-connect.ro",
    siteWeb: "www.telecom-connect.ro",
    telefonFix: "0264.123.456",
    telefonMobil: "0733.456.789",
    puncteLucru: ["Cluj-Napoca - Sediu Central", "Timișoara - Sucursala Vest"],
    caenPrincipal: {
      cod: "6110",
      denumire: "Telecomunicații prin rețele cu fir",
    },
    caenSecundar: [
      { cod: "6120", denumire: "Telecomunicații prin rețele fără fir" },
      { cod: "6190", denumire: "Alte activități de telecomunicații" },
    ],
    nrSalariati: 120,
    cifraAfaceri: 8500000,
    active: 5200000,
    persoanaContact: {
      nume: "Mihai Popescu",
      email: "mihai.popescu@telecom-connect.ro",
      telefon: "0733.456.789",
    },
    scenario: "ENTITATE MIJLOCIE TELECOM → ESENȚIALĂ",
    description:
      "Entitate de dimensiune MIJLOCIE dar furnizor de servicii de telecomunicații. Se încadrează ca ESENȚIALĂ conform excepției pentru serviciile speciale.",
    needsImpactAnalysis: false,
  },

  {
    cui: "34567890",
    denumire: "SC MICRO SOLUTIONS SRL",
    adresaSediu: "Str. Primăverii nr. 12, Brașov, Brașov",
    codPostal: "500123",
    email: "contact@micro-solutions.ro",
    siteWeb: "www.micro-solutions.ro",
    telefonFix: "0268.123.456",
    telefonMobil: "0744.567.890",
    puncteLucru: ["Brașov - Sediu Unic"],
    caenPrincipal: {
      cod: "6201",
      denumire: "Activități de realizare a soft-ului la comandă",
    },
    caenSecundar: [
      {
        cod: "6202",
        denumire: "Activități de consultanță în tehnologia informației",
      },
    ],
    nrSalariati: 8,
    cifraAfaceri: 450000,
    active: 180000,
    persoanaContact: {
      nume: "Ana Dumitru",
      email: "ana.dumitru@micro-solutions.ro",
      telefon: "0744.567.890",
    },
    scenario: "ENTITATE MICRO → ÎN AFARA DOMENIULUI",
    description:
      "Entitate de dimensiune MICRO cu servicii IT. Nu se încadrează în domeniul NIS 2 din cauza dimensiunii prea mici.",
    needsImpactAnalysis: false,
  },

  {
    cui: "45678901",
    denumire: "SC HOSPITAL SYSTEMS SRL",
    adresaSediu: "Calea Dorobanților nr. 89, Iași, Iași",
    codPostal: "700259",
    email: "contact@hospital-systems.ro",
    siteWeb: "www.hospital-systems.ro",
    telefonFix: "0232.456.789",
    telefonMobil: "0755.678.901",
    puncteLucru: ["Iași - Sediu Central", "Suceava - Biroul Regional"],
    caenPrincipal: {
      cod: "8610",
      denumire: "Activități de asistență spitalicească",
    },
    caenSecundar: [
      {
        cod: "6201",
        denumire: "Activități de realizare a soft-ului la comandă",
      },
      {
        cod: "8620",
        denumire: "Activități de asistență medicală specializată",
      },
    ],
    nrSalariati: 320,
    cifraAfaceri: 15800000,
    active: 9200000,
    persoanaContact: {
      nume: "Dr. Georgescu Marian",
      email: "marian.georgescu@hospital-systems.ro",
      telefon: "0755.678.901",
    },
    scenario: "ENTITATE MARE SĂNĂTATE → ANALIZĂ IMPACT NECESARĂ",
    description:
      "Entitate de dimensiune MARE din sectorul sănătății. Necesită analiză de impact pentru a determina dacă se încadrează ca ESENȚIALĂ conform art. 9.1",
    needsImpactAnalysis: true,
  },

  {
    cui: "56789012",
    denumire: "SC LOGISTICS CLOUD SRL",
    adresaSediu: "Șos. București-Ploiești nr. 234, București, Sector 1",
    codPostal: "013681",
    email: "office@logistics-cloud.ro",
    siteWeb: "www.logistics-cloud.ro",
    telefonFix: "021.567.8901",
    telefonMobil: "0766.789.012",
    puncteLucru: [
      "București - Sediu Central",
      "Pitești - Centrul Logistic",
      "Galați - Portul Dunărea",
    ],
    caenPrincipal: {
      cod: "5229",
      denumire: "Alte activități anexe transporturilor",
    },
    caenSecundar: [
      {
        cod: "6311",
        denumire:
          "Activități de procesare a datelor, administrare saiter web și activități conexe",
      },
      {
        cod: "6201",
        denumire: "Activități de realizare a soft-ului la comandă",
      },
    ],
    nrSalariati: 180,
    cifraAfaceri: 12400000,
    active: 7800000,
    persoanaContact: {
      nume: "Radu Constantinescu",
      email: "radu.constantinescu@logistics-cloud.ro",
      telefon: "0766.789.012",
    },
    scenario: "ENTITATE MIJLOCIE ANEXA 1+2 → IMPORTANTĂ",
    description:
      "Entitate de dimensiune MIJLOCIE cu servicii din Anexele 1 și 2. Nu îndeplinește criteriile pentru Esențială, deci se încadrează ca IMPORTANTĂ.",
    needsImpactAnalysis: false,
  },

  {
    cui: "67890123",
    denumire: "AGENȚIA NAȚIONALĂ PENTRU DIGITALIZARE",
    adresaSediu: "Calea Victoriei nr. 152, București, Sector 1",
    codPostal: "010096",
    email: "contact@digitalizare.gov.ro",
    siteWeb: "www.digitalizare.gov.ro",
    telefonFix: "021.678.9012",
    telefonMobil: "0777.890.123",
    puncteLucru: [
      "București - Sediul Central",
      "Cluj-Napoca - Centrul Regional IT",
    ],
    caenPrincipal: {
      cod: "8411",
      denumire: "Activități generale de administrație publică",
    },
    caenSecundar: [
      {
        cod: "6201",
        denumire: "Activități de realizare a soft-ului la comandă",
      },
      {
        cod: "6311",
        denumire:
          "Activități de procesare a datelor, administrare saiter web și activități conexe",
      },
    ],
    nrSalariati: 95,
    cifraAfaceri: 0, // entitate publică
    active: 8500000,
    persoanaContact: {
      nume: "Cristina Păduraru",
      email: "cristina.paduraru@digitalizare.gov.ro",
      telefon: "0777.890.123",
    },
    isAdminPublic: true,
    scenario: "ADMINISTRAȚIE PUBLICĂ → ESENȚIALĂ INDIFERENT DE DIMENSIUNE",
    description:
      "Entitate a administrației publice centrale. Se încadrează automat ca ESENȚIALĂ indiferent de dimensiune sau servicii.",
    needsImpactAnalysis: false,
  },

  {
    cui: "78901234",
    denumire: "SC DNS SECURE ROMANIA SRL",
    adresaSediu: "Bdul Carol I nr. 78, București, Sector 2",
    codPostal: "020917",
    email: "admin@dns-secure.ro",
    siteWeb: "www.dns-secure.ro",
    telefonFix: "021.789.0123",
    telefonMobil: "0788.901.234",
    puncteLucru: [
      "București - Data Center Principal",
      "Timișoara - Data Center Backup",
    ],
    caenPrincipal: {
      cod: "6311",
      denumire:
        "Activități de procesare a datelor, administrare saiter web și activități conexe",
    },
    caenSecundar: [
      {
        cod: "6202",
        denumire: "Activități de consultanță în tehnologia informației",
      },
    ],
    nrSalariati: 45,
    cifraAfaceri: 3200000,
    active: 1850000,
    persoanaContact: {
      nume: "Andrei Stanciu",
      email: "andrei.stanciu@dns-secure.ro",
      telefon: "0788.901.234",
    },
    isFurnizorDNS: true,
    scenario: "FURNIZOR DNS → ESENȚIALĂ INDIFERENT DE DIMENSIUNE",
    description:
      "Furnizor de servicii DNS. Se încadrează automat ca ESENȚIALĂ indiferent de dimensiune conform legislației.",
    needsImpactAnalysis: false,
  },

  {
    cui: "89012345",
    denumire: "SC CERTIFICA TRUST SRL",
    adresaSediu: "Str. Ion Campineanu nr. 56, București, Sector 1",
    codPostal: "010031",
    email: "contact@certifica-trust.ro",
    siteWeb: "www.certifica-trust.ro",
    telefonFix: "021.890.1234",
    telefonMobil: "0799.012.345",
    puncteLucru: ["București - Sediu Central"],
    caenPrincipal: {
      cod: "6920",
      denumire:
        "Activități de contabilitate și audit financiar; consultanță în domeniul fiscal",
    },
    caenSecundar: [
      {
        cod: "6202",
        denumire: "Activități de consultanță în tehnologia informației",
      },
    ],
    nrSalariati: 28,
    cifraAfaceri: 2100000,
    active: 980000,
    persoanaContact: {
      nume: "Maria Vasilescu",
      email: "maria.vasilescu@certifica-trust.ro",
      telefon: "0799.012.345",
    },
    isPrestatorQTSP: true,
    scenario: "PRESTATOR QTSP → ESENȚIALĂ INDIFERENT DE DIMENSIUNE",
    description:
      "Prestator de servicii de încredere calificat. Se încadrează automat ca ESENȚIALĂ indiferent de dimensiune.",
    needsImpactAnalysis: false,
  },

  {
    cui: "90123456",
    denumire: "SC FINANCIAL SYSTEMS SRL",
    adresaSediu: "Bdul Magheru nr. 125, București, Sector 1",
    codPostal: "010435",
    email: "info@financial-systems.ro",
    siteWeb: "www.financial-systems.ro",
    telefonFix: "021.901.2345",
    telefonMobil: "0740.123.456",
    puncteLucru: [
      "București - Sediu Central",
      "Brașov - Centrul de Dezvoltare",
    ],
    caenPrincipal: {
      cod: "6419",
      denumire: "Alte activități de intermedieri monetare",
    },
    caenSecundar: [
      {
        cod: "6201",
        denumire: "Activități de realizare a soft-ului la comandă",
      },
      {
        cod: "6311",
        denumire:
          "Activități de procesare a datelor, administrare saiter web și activități conexe",
      },
    ],
    nrSalariati: 65,
    cifraAfaceri: 4800000,
    active: 2950000,
    persoanaContact: {
      nume: "Florin Munteanu",
      email: "florin.munteanu@financial-systems.ro",
      telefon: "0740.123.456",
    },
    scenario:
      "ENTITATE MIJLOCIE SERVICII FINANCIARE → ANALIZĂ IMPACT PENTRU IMPORTANTĂ",
    description:
      "Entitate mijlocie din sectorul financiar. Necesită analiză de impact pentru a determina dacă se încadrează ca IMPORTANTĂ.",
    needsImpactAnalysis: true,
  },
];

export function getTestEntityByCUI(cui: string): TestEntityData | undefined {
  return TEST_ENTITIES.find((entity) => entity.cui === cui);
}

export function getAllTestScenarios(): {
  cui: string;
  scenario: string;
  description: string;
}[] {
  return TEST_ENTITIES.map((entity) => ({
    cui: entity.cui,
    scenario: entity.scenario,
    description: entity.description,
  }));
}
